// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__W2bjG","title":"CardHeader_title__KdYax"};